module.exports = __webpack_public_path__ + "static/media/03b.a795f05a.png";